// src/store/api.ts
import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '@/api/client'

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Course',
    'Lesson',
    'Block',
    'Category',
    'Me',
    'Author',
    'Instruction',
    'Poster',
    'Video',
    'Connection',
    'Quote',
    'CreditsBalance',
    'CreditsHistory',
    'Moderation',
    'ArticleModeration',
  ],
  endpoints: () => ({}),
})
